import { render, staticRenderFns } from "./ConfigTableInstagram.vue?vue&type=template&id=97bcdf2c&"
import script from "./ConfigTableInstagram.vue?vue&type=script&lang=js&"
export * from "./ConfigTableInstagram.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports